import axios from 'axios'

// 设置sessionId 用户身份
let sessionId = localStorage.getItem('sessionId')
// console.log(1111, sessionId)//第一次引入（未登录）， 已经生成null
axios.defaults.headers.common['sessionId'] = sessionId;

const baseUrl = '/web'


// 个人中心
// 获取侧边栏导航
export const showNavigation = params => axios.get(`/personalCenter/showNavigation`, { params: params })
// 个人资料
export const showPersonalData = params => axios.get(`/personalCenter/showPersonalData`, { params: params })

// 保存头像 
export const changeHeadPortrait = params => axios.post(`/auth/update/changeHeadPortrait`, params)
// 修改个人资料 
export const updatePersonalData = params => axios.post(`/personalCenter/updatePersonalData`, params)

// 获取手机号
export const findPhone = params => axios.get(`/personalCenter/findPhone`, { params: params })
// 短信验证码-修改手机号
export const sendCodeUpdatePhone = params => axios.get(`/personalCenter/sendCodeUpdatePhone`, { params: params })
// 短信验证码-修改支付密码
export const sendCodeUpdatePayPhone = params => axios.get(`/personalCenter/sendCodeUpdatePayPhone`, { params: params })
// 短信验证码-修改登录密码
export const sendCodeUpdatePassword = params => axios.get(`/personalCenter/sendCodeUpdatePassword`, { params: params })
// 修改手机号
export const updateLoginPhone = params => axios.get(`/personalCenter/updateLoginPhone`, { params: params })
// 修改支付密码
export const updatePayPassword = params => axios.get(`/personalCenter/updatePayPassword`, { params: params })
// 修改登录密码
export const updateLoginPassword = params => axios.get(`/personalCenter/updateLoginPassword`, { params: params })


// 实名认证

// 上传身份证-正面
export const idCardFront = params => axios.post(`/auth/update/idCardFront`, params)
// 上传身份证-反面
export const idCardReverse = params => axios.post(`/auth/update/idCardReverse`, params)
// 提交 
export const nameAuthentication = params => axios.get(`/personalCenter/nameAuthentication`, { params: params })
// 邮箱验证码
export const sendCodeUpdateEmail = params => axios.get(`/personalCenter/sendCodeUpdateEmail`, { params: params })

// 个人中心主页
// export const showPersonalCenter = params => axios.get(`/personalCenter/showPersonalCenter`, { params: params })
// 修改
export const findPersonalPageCenter = params => axios.get(`/personalCenter/findPersonalPageCenter`, { params: params })
// 业主页面查询留言板
export const selectContactByOwner = params => axios.get(`/personalCenter/selectContactByOwner`, { params: params })
// 监理页面查询留言板
export const selectContactBySdp = params => axios.get(`/personalCenter/selectContactBySdp`, { params: params })
// 设计师查询
export const selectContactByDes2 = params => axios.get(`/personalCenter/selectContactByDes2`, { params: params })
// 设计师留言
export const sendMessageByDes2 = params => axios.get(`/personalCenter/sendMessageByDes2`, { params: params })

// 业主留言
export const sendMessageByOwner = params => axios.get(`/personalCenter/sendMessageByOwner`, { params: params })

// 监理留言
export const sendMessageBySdp = params => axios.get(`/personalCenter/sendMessageBySdp`, { params: params })

// 项目消息
export const findProjectList = params => axios.get(`/sys/projectMessage/findProjectList`, { params: params })
// 已读项目消息
export const updateIsHandle = params => axios.get(`/sys/projectMessage/updateIsHandle`, { params: params })
export const updateIsHandleAboutUpload = params => axios.get(`/sys/projectMessage/updateIsHandleAboutUpload`, { params: params })
// 项目消息--跳查看进程
export const findSpringboardProcess = params => axios.get(`/sys/projectMessage/findSpringboardProcess`, { params: params })
// 项目消息--跳预算变更
export const findSpringboardBudget = params => axios.get(`/sys/projectMessage/findSpringboardBudget`, { params: params })
// 项目消息--业主处理申请消息
export const ownerAgreeApply = params => axios.get(`/sys/projectMessage/ownerAgreeApply`, { params: params })

// 批量删除已处理信息
export const batchDeleteByIds = params => axios.post(`/sys/projectMessage/batchDeleteByIds`, params)

// 系统消息
export const findPageListByUserId = params => axios.get(`/sys/sysMessage/findPageListByUserId`, { params: params })

// 批量删除系统信息
export const delSysMessage = params => axios.post(`/sys/sysMessage/batchDeleteByIds`, params)

// 已读信息
export const batchSignByIds = params => axios.post(`/sys/sysMessage/batchSignByIds`, params)
// 系统消息详情
export const findMessageById = params => axios.get(`/sys/sysMessage/findMessageById`, { params: params })
// 收到的评论
export const myGetComments = params => axios.get(`/sys/sysComment/myGetComments`, { params: params })
// 批量删除收到的评论
export const batchDeleteGetComments = params => axios.post(`/sys/sysComment/batchDeleteGetComments`, params)
// 已读收到的评论
export const batchUpdateRecipientRead = params => axios.post(`/sys/sysComment/batchUpdateRecipientRead`, params)
// 收到的评论-跳监理现场
export const findSpringboardComments = params => axios.get(`/sys/sysComment/findSpringboardComments`, { params: params })
// 收到的赞
export const receivedThumbs = params => axios.get(`/UserThumbsController/receivedThumbs`, { params: params })
// 批量删除收到的赞
export const batchDeleteByUserId = params => axios.post(`/UserThumbsController/batchDeleteByUserId`, params)
// 已读收到赞
export const batchViewedByUserId = params => axios.post(`/UserThumbsController/batchViewedByUserId`, params)
// 我的评论-跳现场
export const myCommentsSpringboardComments = params => axios.get(`/sys/sysComment/myCommentsSpringboardComments`, { params: params })
// 我的评论
export const myComments = params => axios.get(`/sys/sysComment/myComments`, { params: params })
// 批量删除我的评论
export const batchDeleteComments = params => axios.post(`/sys/sysComment/batchDeleteComments`, params)

// 项目投诉
export const siteComplaint = params => axios.post(`/personalCenter/siteComplaint`, params)
// 投诉图片 单个上传 暂存
export const singlePictureUpload = params => axios.post(`/personalCenter/singlePictureUpload`, params)
// 项目投诉弹框的展示信息
export const sendComplaintAbout = params => axios.get(`/personalCenter/sendComplaintAbout`, { params: params })
// 添加工人-校验手机号
export const checkPhoneByAddWorker = params => axios.get(`/personalCenterBot/checkPhoneByAddWorker`, { params: params })
// 添加工人-确定
export const addWorker = params => axios.get(`/personalCenterBot/addWorker`, { params: params })
// 预算上传-图片
export const singleSaveAllBudget = params => axios.post(`/currencyCenter/singleSaveAllBudget`, params)
// 预算上传-excel
export const singleSaveAllBudgetExcel = params => axios.post(`/currencyCenter/singleSaveAllBudgetExcel`, params)
// 提交
export const addBudget = params => axios.post(`/currencyCenter/addBudget`, params)
// 合同图片 & word
export const singleSaveAllContract = params => axios.post(`/currencyCenter/singleSaveAllContract`, params)
// 合同提交
export const addContract = params => axios.post(`/currencyCenter/addContract`, params)
// 合同再次提交
export const againAddContract = params => axios.post(`/currencyCenter/againAddContract`, params)
// 图纸上传
export const singleSaveAllDrawing = params => axios.post(`/currencyCenter/singleSaveAllDrawing`, params)
// 图纸提交
export const addDrawing = params => axios.post(`/currencyCenter/addDrawing`, params)
//原预算 再次上传
export const againAddBudget = params => axios.post(`/currencyCenter/againAddBudget`, params)
//图纸 再次上传
export const againAddDrawing = params => axios.post(`/currencyCenter/againAddDrawing`, params)
// 阅读协议
export const getTerms = params => axios.get(`/user/terms/getTerms`, { params: params })
// 发送协议 邮件
export const confirmTerms = params => axios.get(`/user/terms/confirmTerms`, { params: params })
// 施工标准权限
export const canLookStandardDetails = params => axios.get(`/sys/standardDetails/canLookStandardDetails`, { params: params })
// 个人中心提示业主是否有未支付项目
export const getPayPrompt = params => axios.get(`/sitePay/getPayPrompt`, { params: params })
// 项目款项 项目列表
export const getSiteListByOwnerId = params => axios.get(`/sitePay/getSiteListByOwnerId`, { params: params })
// 项目款项 支付列表
export const findSitePaySettingBySiteId = params => axios.get(`/sitePay/findSitePaySettingBySiteId`, { params: params })
// 支付信息
export const findPayAboutRequest = params => axios.get(`/sitePay/findPayAboutRequest`, { params: params })
// 微信支付需要信息
export const unifiedOrder = params => axios.get(`/wxMiniController/unifiedOrder`, { params: params })
// 获取标准支付详情
export const findPayInfoByProceId = params => axios.get(`/sitePay/findPayInfoByProceId`, { params: params })
// 收到的评论-跳风险规避
export const findSpringboardCommentsMediation = params => axios.get(`/sys/sysComment/findSpringboardCommentsMediation`, { params: params })
// 合同终止
export const terminationOfContractAbout = params => axios.get(`/user/terms/terminationOfContractAbout`, { params: params })
export const terminationAbout = params => axios.get(`/user/terms/terminationAbout`, { params: params })
// POST 文件上传(文本文件)
export const planSingleSaveAllBudgetExcel = params => axios.post(`/currencyCenter/singleSaveAllBudgetExcel`, params)
// 获取现场id
export const findSiteIdByProcessId = params => axios.get(`/case/findSiteIdByProcessId`, { params: params })
//图纸进程 个人中心 - 查看进程 业主发起图纸变更 - 实地专用
export const ownerApply2 = params => axios.post(`/siteProcDesign/ownerApply2`, params)
/*********************************************施工标准***************************************************************/
//监理 - 根据版本号获取所有标准(包含未上架的)
export const findAllServiceByVersion2 = params => axios.get(`/personalCenterSdp/findAllServiceByVersion2`, { params: params })



// WEBPACK FOOTER //
// ./src/api/personalApi.js